export const validateZipcode = async (zip) => {
  try {
    const response = await fetch(`https://api.zippopotam.us/us/${zip}`);
    if (!response.ok) {
      throw Error("Invalid ZIP Code");
    }
    const data = await response.json();
    return data.places[0]["state abbreviation"] || "";
  } catch (error) {
    console.error("Error fetching ZIP code data:", error);
    return null;
  }
};
